














import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class CloseIcon extends Vue {
  @Prop({ default: '20' }) readonly width?: string;
  @Prop({ default: '20' }) readonly height?: string;
  @Prop({ default: '#3E24D6' }) readonly color?: string;
}
